import { render, staticRenderFns } from "./setores.vue?vue&type=template&id=88b891ac&scoped=true&"
import script from "./setores.vue?vue&type=script&lang=js&"
export * from "./setores.vue?vue&type=script&lang=js&"
import style0 from "./setores.vue?vue&type=style&index=0&id=88b891ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b891ac",
  null
  
)

export default component.exports